import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card p-mb-4" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-6" }
const _hoisted_4 = { class: "p-d-flex p-flex-column" }
const _hoisted_5 = { class: "p-mb-2 p-text-light" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_7 = { class: "p-col-6" }
const _hoisted_8 = { class: "p-d-flex p-flex-column" }
const _hoisted_9 = { class: "p-mb-2 p-text-light" }
const _hoisted_10 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ConfigDs = _resolveComponent("ConfigDs")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t("datasource.list-datasource.table.column.name")), 1),
              _hoisted_6
            ]),
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.autoMlName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.autoMlName = $event)),
              class: "p-inputtext-filled",
              maxlength: "64"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("automl.label.description")), 1),
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.autoMlDescription,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.autoMlDescription = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_ConfigDs, {
        autoMlName: _ctx.autoMlName,
        autoMlDescription: _ctx.autoMlDescription,
        autoMlSchemas: _ctx.autoMlSchemas,
        autoMlTenantId: _ctx.autoMlTenantId,
        datasourceName: _ctx.datasourceName,
        copiedConfig: _ctx.copiedConfig,
        folderId: _ctx.folderId,
        workspaceId: _ctx.workspaceId
      }, null, 8, ["autoMlName", "autoMlDescription", "autoMlSchemas", "autoMlTenantId", "datasourceName", "copiedConfig", "folderId", "workspaceId"])
    ])
  ], 64))
}